import {
    get
} from '../configApi'

export async function getTopSellReport() {
    return await get(`/report/mylib/top`)
}

export async function getGraphSellReport(params) {
    return await get(`/report/mylib/graph`, params)
}

export async function getTableSellReport(params) {
    return await get(`/report/mylib/listsell`, params)
}

export async function getExcel(params) {
    return await get(`/report/mylib/excel`, params)
}
